import { CircleAlert, Package, Star, ThumbsDown, Trophy } from "lucide-react";
import React from "react";
import { renderTextWithLinks } from "@/shared/utils/helperFunctions";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { useLogWhitespaceOutcome } from "@/features/accounts/hooks/useAccounts";
import CurrentVendors from "./CurrentVendors";

const OUTCOME_OPTIONS = [
  {
    value: "won",
    label: "Won",
    icon: <Trophy size={14} />,
    selectedClassName:
      "bg-success-50 dark:bg-emerald-950/70 border-success-200 dark:border-emerald-800/80 text-success-500 dark:text-emerald-400",
  },
  {
    value: "lost",
    label: "Lost",
    icon: <ThumbsDown size={14} />,
    selectedClassName:
      "bg-error-50 dark:bg-rose-950/70 border-error-200 dark:border-rose-800/80 text-error-500 dark:text-rose-400",
  },
];

const AccordianData = ({ data, userId, companyName }) => {
  const { pain_point, our_service_offering, opportunity_score_reason } = data;
  const logOutcome = useLogWhitespaceOutcome({ userId, companyName });

  const formattedData = [
    {
      id: 1,
      title: "Pain",
      description: pain_point,
      icon: <CircleAlert size={16} className="text-gray-800 dark:text-gray-200" />,
    },
    {
      id: 2,
      title: "Solution Proposition",
      description: our_service_offering,
      icon: <Package size={16} className="text-gray-800 dark:text-gray-200" />,
    },
    {
      id: 3,
      title: "Proof",
      description: opportunity_score_reason,
      icon: <Star size={16} className="text-gray-800 dark:text-gray-200" />,
    },
  ];

  const renderSection = (item) => (
    <div className="flex flex-col gap-1.5 py-3" key={item.id}>
      <div className="flex items-center gap-1.5 font-medium text-[0.793rem] leading-5">
        {item.icon}
        {item.title}
      </div>
      <p className="text-[0.693rem] leading-[18px] font-normal whitespace-pre-line break-words">
        {renderTextWithLinks(item.description)}
      </p>
    </div>
  );

  return (
    <div className="px-5 flex flex-col items-start gap-2.5 font-sans text-gray-800 dark:text-gray-200">
      {formattedData.slice(0, 2).map(renderSection)}
      <CurrentVendors
        vendors={data.current_vendors}
        auditId={data.id}
        disabled={!data.id || !data.service_name}
        userId={userId}
        companyName={companyName}
      />
      {formattedData.slice(2).map(renderSection)}
      <div className="flex flex-wrap items-center gap-2 pb-5">
        <span className="text-[0.693rem] leading-[18px] text-gray-500 dark:text-gray-400">
          Outcome after pitching:
        </span>
        {OUTCOME_OPTIONS.map((option) => (
          <SecondaryButton
            key={option.value}
            title={option.label}
            icon={option.icon}
            onClick={() =>
              logOutcome.mutate({ userId, auditId: data.id, outcome: option.value })
            }
            disabled={!data.id || !data.service_name || logOutcome.isPending}
            isLoading={logOutcome.isPending && logOutcome.variables?.outcome === option.value}
            className={`px-2.5 py-1 shadow-none ${data.outcome === option.value ? option.selectedClassName : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AccordianData;
